import { Modal } from '../Modal/Modal';
import { useTranslation } from 'react-i18next';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Container, Detail, Text } from './SubmitBeingCheckedModal.styled';

export interface ISubmitBeingCheckedModalProps {
  isOpen: boolean;
  // Logyx core's own text about the submission, when it gave one.
  message: string | null;
}

// The submission's outcome is unknown: it may already have reached the supplier,
// and Logyx core is checking it. It is final, so the page offers no way to submit
// it again (docs/BP-1219-ordering.md). Like the submitted modal, it stays open.
export function SubmitBeingCheckedModal({
  isOpen,
  message,
}: ISubmitBeingCheckedModalProps) {
  const { t } = useTranslation();
  const { isPhone } = useBreakpointFlag();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => null}
      showCloseIcon={false}
      modalStyle={{
        margin: 'auto',
        height: 'fit-content',
        width: isPhone ? '90%' : '600rem',
        minWidth: isPhone ? '90%' : 'auto',
        position: 'fixed',
      }}
      pwId="submit-being-checked-modal"
    >
      <Container>
        <Text>
          {t(
            'We could not confirm your submission. It may already have reached the supplier, and it is being checked.'
          )}
        </Text>
        <Text>{t('Do not submit it again. You can close this page.')}</Text>
        {message && <Detail>{message}</Detail>}
      </Container>
    </Modal>
  );
}
